'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteTextract = exports.extractScoresAndCreate = exports.updateTextract = undefined;

var _middleware = require('../../middleware');

var _sendEventToTabs = require('../events/sendEventToTabs');

var _sendEventToTabs2 = _interopRequireDefault(_sendEventToTabs);

var _sendEventToQa = require('../events/sendEventToQa');

var _sendEventToQa2 = _interopRequireDefault(_sendEventToQa);

var _deleteEventScoresByAdjudicator = require('../scores/deleteEventScoresByAdjudicator');

var _deleteEventScoresByAdjudicator2 = _interopRequireDefault(_deleteEventScoresByAdjudicator);

var _textractStatuses = require('../../../../lib/utilities/textract-statuses');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var updateTextract = exports.updateTextract = function updateTextract(textractId, feis_id, confidenceScore, countOfErrors, textractStatus) {
  return function (dispatch) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      textractId: textractId

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/textract/' + textractId + '/feiseanna/' + feis_id,
        method: 'PUT',
        data: { confidenceScore: confidenceScore, countOfErrors: countOfErrors, status: textractStatus }
      },
      types: ['UPDATE_TEXTRACT_START', 'UPDATE_TEXTRACT', 'UPDATE_TEXTRACT_ERROR']
    }));
  };
};

var extractScoresAndCreate = exports.extractScoresAndCreate = function extractScoresAndCreate(feis_id, textractId, adjId, eventId, pdfName, eventName) {
  var extractType = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'TABLE';
  var updateTextractRecord = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  var updateEventStatusRecord = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
  var versionId = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 1;
  return function (dispatch) {
    var versionIdForSendingEventToQA = versionId;
    return dispatch((0, _sendEventToTabs2.default)(feis_id, eventId, versionId)).then(function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(eventInTabsResponse) {
        var payload;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                payload = eventInTabsResponse.payload;

                versionIdForSendingEventToQA = payload.version_id;
                _context.next = 4;
                return dispatch((0, _deleteEventScoresByAdjudicator2.default)(feis_id, eventId, adjId));

              case 4:
                return _context.abrupt('return', dispatch(_defineProperty({
                  feis_id: feis_id,
                  textractId: textractId,
                  adjId: adjId,
                  eventId: eventId,
                  extractType: extractType,
                  eventName: eventName

                }, _middleware.CALL_API, {
                  config: {
                    url: IFEIS_API_URI + '/api/textract/' + textractId + '/feiseanna/' + feis_id + '/events/' + eventId + '/adjudicators/' + adjId + '?extractType=' + extractType,
                    method: 'POST',
                    data: { name: pdfName, eventName: eventName }
                  },
                  types: ['EXTRACT_SCORESHEET_CREATE_START', 'EXTRACT_SCORESHEET_CREATE', 'EXTRACT_SCORESHEET_CREATE_ERROR']
                })).then(function (response) {
                  if (updateTextractRecord && response.payload) {
                    var confidenceScore = response.payload[0].confidenceScore;

                    var countOfErrors = (response.payload.find(function (result) {
                      return result.countOfErrors > 0;
                    }) || {}).countOfErrors || 0;
                    return dispatch(updateTextract(textractId, feis_id, confidenceScore, countOfErrors, countOfErrors > 0 ? _textractStatuses.textractStatus.ERROR : _textractStatuses.textractStatus.APPROVED)).then(function (textractResponse) {
                      if (textractResponse.payload) {
                        return dispatch((0, _sendEventToQa2.default)(feis_id, eventId, versionIdForSendingEventToQA));
                      } else {
                        return Promise.reject(textractResponse);
                      }
                    });
                  } else {
                    if (!response.payload) {
                      return Promise.reject(response);
                    }
                    return Promise.resolve(response);
                  }
                }));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function (_x5) {
        return _ref.apply(this, arguments);
      };
    }());
  };
};

var deleteTextract = exports.deleteTextract = function deleteTextract(textractId, feis_id, objectKey) {
  return function (dispatch) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      textractId: textractId,
      objectKey: objectKey

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/textract/' + textractId + '/feiseanna/' + feis_id + '?objectKey=' + objectKey,
        method: 'DELETE'
      },
      types: ['DELETE_TEXTRACT_START', 'DELETE_TEXTRACT', 'DELETE_TEXTRACT_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/textract/saveTextractData.js
// module id = 686
// module chunks = 0